// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';
import { ValidationRulesDisplay } from './ValidationRulesBuilder';

const ViewDocumentType = () => {
  return (
    <ViewEntity
      pageTitle="DocumentTypeInfo"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/document_types/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'code',
          labelKey: 'Code',
          type: 'text',
        },
        {
          name: 'en_name',
          labelKey: 'NameEnglish',
          type: 'text',
        },
        {
          name: 'ar_name',
          labelKey: 'NameArabic',
          type: 'text',
        },
        {
          name: 'validation_rules',
          labelKey: 'IdentifierValidationRules',
          type: 'custom',
          render: (data) => {
            const lang = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
            return (
              <ValidationRulesDisplay
                rules={data.validation_rules}
                lang={lang}
              />
            );
          },
        },
        {
          name: 'discount_bands_count',
          labelKey: 'AssociatedDiscountBands',
          type: 'custom',
          render: (data) => data.discount_bands_count !== undefined ? data.discount_bands_count : '-',
        },
        {
          name: 'fare_media_eligibility_count',
          labelKey: 'AssociatedFareMediaEligibility',
          type: 'custom',
          render: (data) => data.fare_media_eligibility_count !== undefined ? data.fare_media_eligibility_count : '-',
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
        {
          name: 'created_by_username',
          labelKey: 'CreatedBy',
          type: 'text',
        },
        {
          name: 'updated_by_username',
          labelKey: 'UpdatedBy',
          type: 'text',
        }
      ]}
      editUrl="/fare-products/document-types/:id/edit"
      deleteApiUrl="/api/v1/web_portal/fare_media_policy_capping/document_types/:id"
      deleteApiMethod="DELETE"
      backUrl="/fare-products/document-types"
      backButtonLabel="Back"
      buildTitle={(data) => {
        const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
        return currentLanguageCode === 'en-us' ? data.en_name : data.ar_name;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const catName = currentLanguageCode === 'en-us' ? data.en_name : data.ar_name;
        return `${intl.formatMessage({ id: 'AreYouSureDeleteDocumentType' })} ${catName}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="DocumentTypes"
      permissionSystem="fares"
    />
  );
};

export default ViewDocumentType;
